import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { BaseService } from '@kodit/core/services';
import { IzlaznaFakturaDto, IzlazneFaktureClient } from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IzlaznaFakturaZaRadniNalogResolver
  extends BaseService
  implements Resolve<IzlaznaFakturaDto> {
  constructor(private _client: IzlazneFaktureClient, private _router: Router) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<IzlaznaFakturaDto>
    | Promise<IzlaznaFakturaDto>
    | IzlaznaFakturaDto
    | null {
    let racunId = 0;
    try {
      racunId = this._router.getCurrentNavigation().extras.state.racunId;
    } catch {
      return null;
    }

    return this._client.getNewForRadniNalog(racunId).pipe(
      map((res) => res.data),
      catchError(this.handleError),
      finalize(() => {})
    );
  }
}
